import MidSectionProductPage from "./MidSectionProductPage.container";

export default MidSectionProductPage;
